import React from "react";
import {useParams} from "react-router-dom";

import Grid from '@material-ui/core/Grid';
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import SaveAltIcon from "@material-ui/icons/SaveAlt";

import PrimaryButton from "../../../../../../../../components/Buttons/PrimaryButton";
import {downloadPdf} from "../../../../../../../../utils/utils";
import {displayErrorSnackBar} from "../../../../../../../../components/SnackbarProvider/actions";
import Chart from "../Summary/components/Chart";
import InfoCard from "../../DynamicStep/components/InfoCard";
import DisclaimerTextV2 from "../DisclaimerText/DisclaimerTextV2";
import {Info} from "../../../question/ChecboxCardQuestion/components/CheckboxCard";

import useStyles from "./styles";

const CATEGORIES = {
  "esg": "ESG",
  "pai": "PAI",
  "ecologically-sustainable": "Ökologisch Nachhaltig"
};

const Summary = (props) => {
  const {dataService} = props;

  const [fileDownloadingProgress, setFileDownloadingProgress] = React.useState(false);

  let {customer_id} = useParams();

  const sustainableStep = dataService.getStep("ecologically-sustainable");

  const esgStep = dataService.getStep("esg");

  const paiStep = dataService.getStep("pai");

  const steps = [sustainableStep, esgStep, paiStep];

  const getQuestion = (step, uid) => {
    return step.question.find(item => item.uid === uid);
  };

  const getPercent = (step) => {
    const question = getQuestion(step, 'percent');

    return question.answer
  };

  const getAspects = (step) => {
    const question = getQuestion(step, 'aspects');

    if (question.answer) {
      return question.config.choices.filter(element => question.answer.includes(element.uid))
    } else {
      return []
    }
  };

  const sustainablePercent = getPercent(sustainableStep);
  const esgPercent = getPercent(esgStep);
  const paiPercent = getPercent(paiStep);


  const data = [];

  steps.forEach(step => {
    const aspects = getAspects(step);
    const percent = getPercent(step);

    data.push({
      "uid": step.uid,
      "aspects": aspects,
      "percent": percent
    })
  });


  const classes = useStyles();

  const handlePdfDownload = () => {

    let requestBody = {
      'customer_id': customer_id,
      'session_id': dataService.onboarding_uid
    };

    setFileDownloadingProgress(true);

    downloadPdf(`/reports/onboarding/esg-profile-pdf/`, undefined, 'POST', undefined, requestBody)
      .then(() => setFileDownloadingProgress(false))
      .catch(error => {
        setFileDownloadingProgress(false);
        props.dispatch(displayErrorSnackBar("Fehler bei der PDF-Erstellung"))
      });
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} lg={6}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography className={classes.title}>
              Ihr Kunde/Ihre Kundin möchte in nachhaltige Produkte investieren
            </Typography>
          </Grid>
          <Grid item xs={12} style={{display: 'flex', justifyContent: 'center'}}>
            <div className={classes.chart}>
              <Chart
                esgPercent={esgPercent}
                paiPercent={paiPercent}
                sustainablePercent={sustainablePercent}
                notitle
              />
            </div>
          </Grid>
          <Grid item xs={12} style={{textAlign: 'center'}}>
            <PrimaryButton
              text={"Nachhaltigkeitsprofil als PDF herunterladen"}
              variant={"text"}
              disabled={fileDownloadingProgress}
              icon={fileDownloadingProgress ?
                <CircularProgress style={{color: 'rgba(0, 0, 0, 0.26)'}} size={15}/> : <SaveAltIcon/>}
              onButtonClick={handlePdfDownload}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} lg={6}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.title}>
              Ihr Kundenportfolio soll idealerweise diese Vorgabe erfüllen:
            </div>
            <div>
              Diese Filter sind in der Übersicht der Produktauswahl berücksichtigt und entsprechende Produkte werden gekennzeichnet.
            </div>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              {data.filter(category => category.aspects.length > 0 && category.percent !== 0).map((category) => (
                <Grid item xs={12}>
                  <Grid container className={classes.card}>
                    <Grid item xs={12}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Grid container justify={"space-between"} className={classes.categoryTitle}>
                            <Grid item>{CATEGORIES[category.uid]}</Grid>
                            <Grid item>{category.percent} %</Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12} className={classes.aspects}>
                          {category.aspects.map((option) => (
                            <Grid container spacing={1}>
                              <Grid item xs={'auto'} className={classes.icon}>
                                <i className={'fal fa-check'} />
                              </Grid>
                              <Grid item xs>{option.text}</Grid>
                              {!!option.info && <Info info={option.info} label={option.text} />}
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid items xs={12}>
        <InfoCard uid={'disclaimer'} info_text={<DisclaimerTextV2 />} isNewDesign />
      </Grid>
    </Grid>
  );
};


export default Summary;
